module.exports = __webpack_public_path__ + "img/upsLogo.bf609254.png";